/**
 *  半角小文字英数字（a-z, 0-9）のみ入力可能
 *  alpha_numは日本語を許容してしまうため、validatorファイルを追加
 *  is-half-width-alpha-numericは大文字を許容してしまうので当validatorファイルを追加
 */

export default {
  validate(value: string | undefined | null): boolean {
    if (!value) {
      return true;
    }
    return /^[a-z0-9]*$/.test(value);
  },
};
